import{createBrowserHistory}from'history';// Export history in order to make it available to Redux actions
// via https://stackoverflow.com/questions/48514773
var history=createBrowserHistory();export default history;